import { Skeleton } from '@/_components';
import { CardContainer, ImageTextHeader, PageHeaderCtrlContainer } from '@/_containers';
import { PageHeaderContainer } from '@/_containers/headers/page/page-header-container';

export function HeaderLoading() {
  return (
    <CardContainer bodyClassName="flex">
      <PageHeaderContainer>
        <ImageTextHeader
          imageSlot={<Skeleton className="h-24 w-[7.84rem] rounded-xl md:h-28 md:w-[9.49rem]" />}
          primarySlot={<Skeleton className="mt-2 h-7 w-44" />}
          secondarySlot={
            <PageHeaderCtrlContainer className="ml-0">
              <Skeleton className="h-6 w-24" />
              <div className="border-c-border-muted mt-1 h-5 w-px border-r" />
              <Skeleton className="h-6 w-24" />
            </PageHeaderCtrlContainer>
          }
        />
      </PageHeaderContainer>
    </CardContainer>
  );
}
